// @tennis-matches/services/trainerstunden/billing-statement-db-compat
// Abwärtskompatibilität, wenn Snapshot-Migrationen noch nicht auf der DB liegen.

/**
 * @param {unknown} err
 */
export function isTrainerstundenBillingMissingColumnError(err) {
  const e = err && typeof err === "object" ? err : {};
  const code = String(e.code || "").trim();
  const msg = String(e.message || e.details || err || "").toLowerCase();
  return (
    code === "42703" ||
    code === "PGRST204" ||
    /column .+ does not exist|could not find the '.+' column/i.test(msg)
  );
}

/**
 * Bereits verschickte Rechnung — Nachversand (gleiche Rechnungsnummer, kein Reset).
 *
 * @param {object | null | undefined} st
 */
export function billingStatementIsInvoiceResendEligible(st) {
  const row = st && typeof st === "object" ? st : {};
  if (String(row.document_kind || "").trim() === "storno") return false;
  const status = String(row.status || "").trim();
  if (!["sent", "partially_paid", "paid"].includes(status)) return false;
  return (
    Boolean(String(row.sent_at || "").trim()) ||
    Boolean(String(row.invoice_frozen_at || "").trim()) ||
    Boolean(String(row.payment_reference || "").trim())
  );
}

/**
 * Braucht die Rechnung vor Erstversand ein Reset (Storno / inkonsistenter Entwurf)?
 * Bereits versendete Rechnungen nutzen {@link billingStatementIsInvoiceResendEligible} — kein Reset.
 *
 * @param {object | null | undefined} st
 */
export function billingStatementNeedsReissuePrep(st) {
  const row = st && typeof st === "object" ? st : {};
  if (billingStatementIsInvoiceResendEligible(row)) return false;
  const status = String(row.status || "").trim();
  if (status === "cancelled") return true;
  if (status === "draft") {
    return (
      Boolean(String(row.sent_at || "").trim()) ||
      Boolean(String(row.invoice_frozen_at || "").trim())
    );
  }
  return false;
}

/**
 * @param {import('@supabase/supabase-js').SupabaseClient} sb
 * @param {string} id
 * @param {Record<string, unknown>} fullPatch
 * @param {Record<string, unknown>} corePatch
 */
export async function updateBillingStatementWithSchemaFallback(
  sb,
  id,
  fullPatch,
  corePatch,
) {
  const sid = String(id || "").trim();
  if (!sb || !sid) return { ok: false, reason: "missing-input" };

  const run = async (patch) =>
    sb
      .from("trainerstunden_billing_statements")
      .update(patch)
      .eq("id", sid)
      .select()
      .single();

  const first = await run(fullPatch);
  if (!first.error) return { ok: true, data: first.data, usedCoreOnly: false };

  if (!isTrainerstundenBillingMissingColumnError(first.error)) {
    return { ok: false, error: first.error };
  }

  const second = await run(corePatch);
  if (second.error) return { ok: false, error: second.error };
  return { ok: true, data: second.data, usedCoreOnly: true };
}
